const BUSINESS_STATES = {
  MANUFACTURED: 'manufactured',
  IN_TRANSIT: 'in-transit',
  AVAILABLE: 'available',
  PAIRED: 'paired',
  SOLD: 'sold',
  SOLD_LOW_BATTERY: 'sold-low-battery',
  SOLD_OFFLINE: 'sold-offline',
  SUSPECTED_DRIVE_OFF: 'suspected-drive-off',
  NOT_REPORTING: 'not-reporting',
  NON_OPERATIONAL: 'non-operational',
  SUBSCRIPTION_EXPIRED: 'subscription-expired',
  STOLEN: 'stolen',
  SUPPORT_REQUIRED: 'support-required',
  LOST: 'lost',
  SUSPECTED_OFF_LOT: 'suspected-off-lot'
};
const OPERATION_STATES = {
  SHIPMENT: 1,
  FACTORY_DEFAULT: 2,
  LM_IDLE: 8,
  LM_ACTIVE: 9,
  TR_IDLE: 10,
  TR_ACTIVE: 11,
  DISABLED: 12
};
const STATE_CONFIG_VERSIONS = {
  PAIRED: '1.5.3',
  UNPAIRED: '1.2.3'
};
export default {
  BUSINESS_STATES,
  OPERATION_STATES,
  STATE_CONFIG_VERSIONS
};